import { useState } from 'react';

import styled from 'styled-components';
import {
    Card,
    Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useNavigate } from 'react-router-dom';

import { IconCircleCheckFilled } from '@tabler/icons-react';

import { useBillingHook } from '../../../Hooks/Billings/billingHooks';

import { CheckoutBillingInfoInterface } from '../../../Models/Common/CustomViewsInterfaces';

import RequiredParametersHelper from '../../../Utilities/Helpers/RequiredParametersHelper';
import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';
import RequiredFieldHelper from '../../../Utilities/Helpers/RequiredFieldHelper';

import { CheckoutField, CompanyAddressField } from '../../../Utilities/Enums/ParametersEnum';
import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';
import { RouteEnum } from '../../../Utilities/Enums/RouteEnums';
import { ViewType } from '../../../Utilities/Enums/ViewTypeEnum';

import CustomStepContent from '../../../CustomViews/Elements/CustomStepper/CustomStepContent';
import GeneratedLicenseKey from '../../../CustomViews/Pages/GeneratedLicenseKey/GeneratedLicenseKey';

export default function Finish(props: CheckoutBillingInfoInterface) {
    let requiredFields = RequiredParametersHelper.checkoutBillingInfo();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    //Use States
    let [errorMessages, setErrorMessages]: any = useState({});
    const [queryStr, setQueryStr] = useState({
        pageSize: 10,
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

    const q_queryKey = [CachingEnum.BILLINGS, queryStr];
    const { DropdownData, dropdownFetchStatus } = useBillingHook(q_queryKey, queryStr, false);
    
    //Variables
    
    //Event Handlers
    return <CustomStepContent
            children={<>
                <GeneratedLicenseKey
                    headerTitle={"Thank you ! Your Order is Completed !"}
                    headerSubTitle={"You will receive an order confirmation email with details of your order."}
                    licenseKey={props?.licenseKey ?? ""}
                    invoiceNo={props?.invoiceId ?? ""}
                    hideLicensePageButton={true}
                    onclickInvoiceNo={() => {
                        navigate(`${RouteEnum.BILLING_DETAILS}?id=${props?.invoicePublicId ?? "0"}&view=${ViewType.PREVIEW}`, { replace: true });

                        if(props?.isFromBilling && props?.onClickBackBtn) {
                            props?.onClickBackBtn();
                        }
                    }}
                    onclickLicenseKey={() => {
                        if(props?.licensePublicId != null && props?.licensePublicId != "") {
                            navigate(`${RouteEnum.LICENSE_DETAILS}?id=${props?.licensePublicId}`, { replace: true });
                        }
                    }} />
            </>} />
}
